import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { setAddressRedux } from "../../redux/slices/addressSlice.ts";
import styles from "./css/Checkout.module.css";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { loadStripe } from "@stripe/stripe-js";
import sendEmail from "../../emailutil";
import { countries } from "../../countries";

import {
  Elements,
  PaymentElement,
  useStripe,
  useElements,
  StripeElementsOptions,
} from "@stripe/react-stripe-js";

import {
  SelectChangeEvent,
  FormControl,
  Select,
  MenuItem,
  TextField,
} from "@mui/material";

// Define types for the cart item
interface CartItem {
  name?: string;
  price?: number;
  quantity?: number;
}
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY!);

const Checkout: React.FC = () => {
  const reduxState = useSelector((state: any) => state);
  const [currentUserEmail, setCurrentUserEmail] = useState(
    reduxState.user.email
  );
  const [message, setMessage] = useState<string | null>(null);
  const cartItems = JSON.parse(localStorage.getItem("cartItems") || "[]");
  const totalPrice = cartItems.reduce(
    (sum, item) => sum + item.price * item.quantity,
    0
  );

  const reduxStateLanguage = useSelector((state: any) => state.language.value);

  const handleCurrentEmailChange = (e: any) => {
    setCurrentUserEmail(e.target.value);
  };

  const user = useSelector((state: any) => state.user);
  const dispatch = useDispatch<any>();
  const [clientSecret, setClientSecret] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [address, setAddress] = useState("");
  const [zipCode, setZipCode] = useState("");
  const [appartment, setAppartment] = useState("");
  const [recepientEmail, setRecepientEmail] = useState(
    reduxState.address.email
  );
  const [city, setCity] = useState("");
  const [selectedCountry, setSelectedCountry] = useState("");
  const navigate = useNavigate();

  const format = cartItems[0]?.format || "";
  const bookLanguage = cartItems[0]?.language || "";

  useEffect(() => {
    console.log(reduxState);
    console.log(recepientEmail);
    console.log("reduxState ^^^");
  }, []);

  useEffect(() => {
    const accessToken = localStorage.getItem("accessToken");

    // If format is not "physical" and accessToken is missing, redirect to login
    if (format !== "physical" && !accessToken) {
      navigate("/login");
    }
  }, []);

  const [quantity, setQuantity] = useState(
    localStorage.getItem("quantity") || 1
  );

  const handleEmailChange = (e: any) => {
    setEmail(e.target.value);
    dispatch(setAddressRedux({ field: "email", value: e.target.value }));
  };

  const handleFirstNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newFirstName = e.target.value;
    setFirstName(newFirstName);
    dispatch(setAddressRedux({ field: "firstName", value: newFirstName }));
    console.log(reduxState);
    console.log("^ reduxState");
  };

  const handleLastNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newLastName = e.target.value;
    setLastName(newLastName);
    dispatch(setAddressRedux({ field: "lastName", value: newLastName }));
  };

  const handleAddressChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newAddress = e.target.value;
    setAddress(newAddress);
    dispatch(setAddressRedux({ field: "address", value: newAddress }));
  };

  const handleZipCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newZipCode = e.target.value;
    setZipCode(newZipCode);
    dispatch(setAddressRedux({ field: "zipCode", value: newZipCode }));
  };

  const handleAppartmentChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newAppartment = e.target.value;
    setAppartment(newAppartment);
    dispatch(setAddressRedux({ field: "appartment", value: newAppartment }));
  };

  const handleCityChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newCity = e.target.value;
    setCity(newCity);
    dispatch(setAddressRedux({ field: "city", value: newCity }));
  };

  const handleCountryChange = (e: SelectChangeEvent) => {
    const newCountry = e.target.value;
    setSelectedCountry(newCountry);
    dispatch(setAddressRedux({ field: "selectedCountry", value: newCountry }));
  };

  useEffect(() => {
    axios
      .post(
        `${process.env.REACT_APP_SERVER_URL}/purchases/create-payment-intent`,
        {
          amount: totalPrice,
          currency: "ron",
        }
      )
      .then((response) => {
        console.log("Payment Intent Response:", response.data);
        if (response.data.clientSecret) {
          setClientSecret(response.data.clientSecret);
        } else {
          console.error("No client secret in response");
          setMessage("Failed to initialize payment");
        }
      })
      .catch((error) => {
        console.error("Error fetching clientSecret:", error);
        setMessage(
          error.response?.data?.error || "Failed to initialize payment"
        );
      });
  }, [totalPrice]);

  // Add this useEffect to load user address data when component mounts
  useEffect(() => {
    // If user has address data in Redux state, use it
    if (user) {
      setEmail(user.email || "");
      setFirstName(user.firstName || "");
      setLastName(user.lastName || "");
      setAddress(user.address || "");
      setZipCode(user.zip || "");
      setAppartment(user.apartment || "");
      setCity(user.city || "");
      setSelectedCountry(user.country || "");
    }

    // If not logged in or no address data, try to fetch from profile
    if (localStorage.getItem("accessToken")) {
      axios
        .get(`${process.env.REACT_APP_SERVER_URL}/auth/profile`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        })
        .then((response) => {
          if (response.data && response.data.address) {
            setEmail(response.data.email || "");
            setFirstName(response.data.firstName || "");
            setLastName(response.data.lastName || "");
            setAddress(response.data.address.address || "");
            setZipCode(response.data.address.zipCode || "");
            setAppartment(response.data.address.appartment || "");
            setCity(response.data.address.city || "");
            setSelectedCountry(response.data.address.selectedCountry || "");
          }
        })
        .catch((error) => {
          console.error("Error fetching user profile:", error);
        });
    }
  }, [user]);

  const options: StripeElementsOptions = {
    clientSecret,
    appearance: {
      theme: "stripe",
      variables: {
        colorPrimary: "#517059",
      },
    },
  };

  useEffect(() => {
    console.log(user);
  }, [user]);

  const handleEmail = (e: React.ChangeEvent<HTMLInputElement>) => {
    const emailData = {
      userEmail: email,
      itemName: "",
      subject: "Purchase Confirmation and Delivery",
      message: `Email: ${email}<br>
        Name: ${firstName} ${lastName}<br>
    
         Country: ${selectedCountry}<br>
        City: ${city}<br>
            Address: ${address}<br>
        Zip Code: ${zipCode}<br>
        Appartment: ${appartment}<br>
       `,
    };

    console.log(emailData);
    console.log("email data here");
  };

  const validateForm = () => {
    if (!email) {
      return "Email is required.";
    }
    if (!firstName) {
      return "First name is required.";
    }
    if (!lastName) {
      return "Last name is required.";
    }
    if (!address) {
      return "Address is required.";
    }
    if (!zipCode) {
      return "Zip code is required.";
    }
    if (!appartment) {
      return "Appartment is required.";
    }
    if (!city) {
      return "City is required.";
    }

    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    if (!emailRegex.test(email)) {
      return "Please enter a valid email address.";
    }

    // Validate zip code (adjust this based on the country format if necessary)
    // const zipCodeRegex = /^\d{5}$/;
    if (!zipCode) {
      return "Please enter a valid zip code.";
    }

    return null;
  };

  useEffect(() => {
    console.log("Redux Address State:", {
      email,
      firstName,
      lastName,
      address,
      city,
      zipCode,
      appartment,
      selectedCountry,
    });
  }, [
    email,
    firstName,
    lastName,
    address,
    city,
    zipCode,
    appartment,
    selectedCountry,
  ]);

  return (
    <div className={styles.productContainer}>
      <div className={styles.productInfo}>
        <div className={styles.frameCartContainer}>
          {format === "physical" && (
            <div className={styles.frame}>
              <span className={styles.productTitle7}>Delivery</span>
              <div className={styles.form}>
                <div className={styles.inputs}>
                  <div className={styles.inputFieldA}>
                    <TextField
                      sx={{
                        width: "100%",
                        height: "inherit",
                        "& .MuiFilledInput-root": {
                          height: "inherit",
                        },
                        "&.css-1pht7va-MuiInputBase-root-MuiFilledInput-root::after ":
                          {
                            content: "none",
                            display: "none",
                            border: "unset",
                          },
                      }}
                      hiddenLabel
                      type="text"
                      onChange={handleEmailChange}
                      value={email}
                      id="filled-hidden-label-normal"
                      placeholder="E-mail"
                      variant="filled"
                    />{" "}
                  </div>
                  {/* <div className={styles.inputField}>
                <FormControl
                  sx={{ width: "100%", border: "none", borderRadius: "0" }}
                >
                  <Select
                    sx={{ border: "none", borderRadius: "0" }}
                    value={selectedCountry}
                    onChange={() => handleCountryChange}
                    displayEmpty
                  >
                    <MenuItem value="">
                      <em>Страна</em>
                    </MenuItem>
                    {countries.map((country) => (
                      <MenuItem key={country} value={country}>
                        {country}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div> */}
                </div>
                <div className={styles.inputField9}>
                  <div className={styles.names}>
                    <div className={styles.inputFieldA}>
                      <TextField
                        sx={{
                          width: "100%",
                          height: "inherit",
                          "& .MuiFilledInput-root": {
                            height: "inherit",
                          },
                          "&.css-1pht7va-MuiInputBase-root-MuiFilledInput-root::after ":
                            {
                              content: "none",
                              display: "none",
                              border: "unset",
                            },
                        }}
                        hiddenLabel
                        onChange={handleFirstNameChange}
                        value={firstName}
                        type="text"
                        id="filled-hidden-label-normal"
                        placeholder="First Name"
                        variant="filled"
                      />{" "}
                    </div>
                    <div className={styles.inputFieldA}>
                      <TextField
                        sx={{
                          width: "100%",
                          height: "inherit",
                          "& .MuiFilledInput-root": {
                            height: "inherit",
                          },
                          "&.css-1pht7va-MuiInputBase-root-MuiFilledInput-root::after ":
                            {
                              content: "none",
                              display: "none",
                              border: "unset",
                            },
                        }}
                        hiddenLabel
                        type="text"
                        value={lastName}
                        onChange={handleLastNameChange}
                        id="filled-hidden-label-normal"
                        placeholder="Last Name"
                        variant="filled"
                      />{" "}
                    </div>
                  </div>
                  <div className={styles.inputFieldA}>
                    <TextField
                      sx={{
                        width: "100%",
                        height: "inherit",
                        "& .MuiFilledInput-root": {
                          height: "inherit",
                        },
                        "&.css-1pht7va-MuiInputBase-root-MuiFilledInput-root::after ":
                          {
                            content: "none",
                            display: "none",
                            border: "unset",
                          },
                      }}
                      hiddenLabel
                      value={address}
                      onChange={handleAddressChange}
                      type="text"
                      id="filled-hidden-label-normal"
                      placeholder="Address"
                      variant="filled"
                    />{" "}
                  </div>

                  <div className={styles.inputFieldA}>
                    <TextField
                      sx={{
                        width: "100%",
                        height: "inherit",
                        "& .MuiFilledInput-root": {
                          height: "inherit",
                        },
                        "&.css-1pht7va-MuiInputBase-root-MuiFilledInput-root::after ":
                          {
                            content: "none",
                            display: "none",
                            border: "unset",
                          },
                      }}
                      value={appartment}
                      onChange={handleAppartmentChange}
                      hiddenLabel
                      type="text"
                      id="filled-hidden-label-normal"
                      placeholder="Appartment, suite, etc. (optional)"
                      variant="filled"
                    />{" "}
                  </div>
                  <div className={styles.names}>
                    <div className={styles.inputFieldA}>
                      <TextField
                        sx={{
                          width: "100%",
                          height: "inherit",
                          "& .MuiFilledInput-root": {
                            height: "inherit",
                          },
                          "&.css-1pht7va-MuiInputBase-root-MuiFilledInput-root::after ":
                            {
                              content: "none",
                              display: "none",
                              border: "unset",
                            },
                        }}
                        hiddenLabel
                        type="text"
                        value={zipCode}
                        onChange={handleZipCodeChange}
                        id="filled-hidden-label-normal"
                        placeholder="Postal Code (optional)"
                        variant="filled"
                      />{" "}
                    </div>
                    <div className={styles.inputFieldA}>
                      <TextField
                        sx={{
                          width: "100%",
                          height: "inherit",
                          "& .MuiFilledInput-root": {
                            height: "inherit",
                          },
                          "&.css-1pht7va-MuiInputBase-root-MuiFilledInput-root::after ":
                            {
                              content: "none",
                              display: "none",
                              border: "unset",
                            },
                        }}
                        hiddenLabel
                        type="text"
                        onChange={handleCityChange}
                        value={city}
                        id="filled-hidden-label-normal"
                        placeholder="City"
                        variant="filled"
                      />{" "}
                    </div>
                    <div className={styles.inputFieldA}>
                      <Select
                        sx={{ border: "none", borderRadius: "0" }}
                        value={selectedCountry}
                        onChange={handleCountryChange}
                        displayEmpty
                      >
                        <MenuItem value="">
                          <em>
                            {reduxStateLanguage === "RO" ? "Țară" : "Country"}
                          </em>
                        </MenuItem>
                        {countries.map((country) => (
                          <MenuItem key={country} value={country}>
                            {country}
                          </MenuItem>
                        ))}
                      </Select>
                    </div>
                  </div>
                </div>
              </div>

              {/* <button className={styles.buttonE}>
            <span className={styles.addToCartF}>Update</span>
          </button> */}
            </div>
          )}
          {clientSecret ? (
            <>
              {" "}
              {format != "physical" && (
                <div
                  className={styles.inputFieldA}
                  style={{ marginTop: "10px" }}
                >
                  <TextField
                    sx={{
                      width: "100%",
                      height: "inherit",
                      "& .MuiFilledInput-root": {
                        height: "inherit",
                      },
                      "&.css-1pht7va-MuiInputBase-root-MuiFilledInput-root::after ":
                        {
                          content: "none",
                          display: "none",
                          border: "unset",
                        },
                    }}
                    hiddenLabel
                    type="text"
                    onChange={handleCurrentEmailChange}
                    value={currentUserEmail}
                    placeholder="Email"
                    id="filled-hidden-label-normal"
                    variant="filled"
                  />{" "}
                </div>
              )}
              <Elements stripe={stripePromise} options={options}>
                <CheckoutForm
                  format={format}
                  validation={validateForm}
                  total={totalPrice}
                  email={email ? email : currentUserEmail}
                  quantity={quantity}
                  bookLanguage={bookLanguage}
                  sendEmail={sendEmail}
                  cartItems={cartItems}
                  firstName={firstName}
                  lastName={lastName}
                  address={address}
                  city={city}
                  zipCode={zipCode}
                  appartment={appartment}
                  selectedCountry={selectedCountry}
                />
              </Elements>
            </>
          ) : (
            <p>Loading payment form...</p>
          )}
        </div>
        <div className={styles.frameCartOverview}>
          <div className={styles.orderDetails}>Order Details</div>
          {cartItems.map((item, index) => (
            <div key={index} className={styles.orderItem}>
              <div className={styles.itemContainer}>
                <div className={styles.leftContent}>
                  <img
                    src={item.image}
                    alt={item.name || "Item Image"}
                    className={styles.productImage}
                  />
                  <div className={styles.itemInfo}>
                    <h3 className={styles.productName}>{item.name}</h3>
                    <div className={styles.itemDetails}>
                      <div>Format: {item.format}</div>
                      <div>Language: {item.language}</div>
                      <div>Quantity: x{item.quantity}</div>
                    </div>
                  </div>
                </div>
                <div className={styles.priceTag}>{item.price} lei</div>
              </div>
              {index < cartItems.length - 1 && (
                <div className={styles.divider} />
              )}
            </div>
          ))}
          <div className={styles.totalPrice}>
            <div>Total: {totalPrice} lei</div>
          </div>
        </div>
      </div>
    </div>
  );
};

const CheckoutForm: React.FC<{
  validation: any;
  total: number;
  email: string;
  cartItems: any;
  quantity: any;
  bookLanguage: string;
  format: string;
  sendEmail: () => void;
  firstName: string;
  lastName: string;
  address: string;
  city: string;
  zipCode: string;
  appartment: string;
  selectedCountry: string;
}> = ({
  validation,
  total,
  email,
  cartItems,
  quantity,
  bookLanguage,
  format,
  sendEmail,
  firstName,
  lastName,
  address,
  city,
  zipCode,
  appartment,
  selectedCountry,
}) => {
  const [additionalEmail, setAdditionalEmail] = useState("");
  const navigate = useNavigate();
  const stripe = useStripe();
  const elements = useElements();
  const [message, setMessage] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [clientSecret, setClientSecret] = useState<string | null>(null);

  // Debugging logs
  useEffect(() => {
    console.log("🚀 Cart Items Updated:", cartItems);
  }, [cartItems]);

  useEffect(() => {
    console.log("🔑 Updated Client Secret:", clientSecret);
  }, [clientSecret]);

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();

    if (!stripe || !elements) {
      console.error("Stripe not initialized");
      return;
    }

    setIsLoading(true);

    try {
      const { error, paymentIntent } = await stripe.confirmPayment({
        elements,
        confirmParams: {
          return_url: `https://google.com`,
        },
        redirect: "if_required",
      });

      if (error) {
        console.error("Payment error:", error);
        setMessage(error.message || "Payment failed");
      } else if (paymentIntent) {
        console.log("Payment Intent:", paymentIntent);
        if (paymentIntent.status === "succeeded") {
          const serializedItems = cartItems
            .map((item: any) => encodeURIComponent(item.name))
            .join(",");

          const itemFormat = cartItems[0]?.format || "physical";
          const itemQuantity = cartItems[0]?.quantity || 1;

          // Log form values before sending
          console.log("Form values being sent:", {
            firstName,
            lastName,
            email,
            address,
            city,
            zipCode,
            appartment,
            selectedCountry,
          });

          // Store form data in sessionStorage as backup
          const formData = {
            firstName,
            lastName,
            email,
            address,
            city,
            zipCode,
            appartment,
            selectedCountry,
          };
          sessionStorage.setItem("checkoutFormData", JSON.stringify(formData));

          const encodedAddressData = encodeURIComponent(
            JSON.stringify(formData)
          );

          const successUrl = `${window.location.origin}/#/checkout-success?payment_intent=${paymentIntent.id}&total=${total}&items=${serializedItems}&email=${email}&quantity=${itemQuantity}&format=${itemFormat}&language=${bookLanguage}&addressData=${encodedAddressData}`;

          console.log("Redirecting to:", successUrl);
          window.location.href = successUrl;
        }
      }
    } catch (error) {
      console.error("Payment error:", error);
      setMessage("Payment failed");
    }

    setIsLoading(false);
  };

  useEffect(() => {
    console.log("🔄 Checking Payment Intent...");
    checkPayment(total);
  }, []);

  const checkPayment = (total: number) => {
    if (!clientSecret) {
      console.log("Creating new Payment Intent...");
      axios
        .post(
          `${process.env.REACT_APP_SERVER_URL}/purchases/create-payment-intent`,
          {
            amount: total,
            currency: "ron",
          }
        )
        .then((response) => {
          console.log("Payment Intent Created:", response.data);
          if (response.data.clientSecret) {
            setClientSecret(response.data.clientSecret);
          } else {
            console.error("No client secret in response");
            setMessage("Failed to initialize payment");
          }
        })
        .catch((error) => {
          console.error("Error creating Payment Intent:", error);
          setMessage(
            error.response?.data?.error || "Failed to initialize payment"
          );
        });
    }
  };

  return (
    <form onSubmit={handleSubmit} className={styles.paymentForm}>
      <PaymentElement />
      <button
        className={styles.buttonE}
        style={{ marginTop: "10px", color: "white" }}
        disabled={!stripe || !clientSecret || isLoading}
      >
        {isLoading ? "Processing..." : "Pay Now"}
      </button>
      {message && <div className={styles.errorMessage}>{message}</div>}
    </form>
  );
};

export default Checkout;
